module.exports = __webpack_public_path__ + "static/chiron-a6d0f741f4f8eb6b61da13b11e226b48.png";